import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { CommonModule } from '@angular/common';
import { LogService } from '../../core/services/log.service';

@Component({
  selector: 'app-signin',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './signin.html',
  styleUrl: './signin.scss'
})
export class Signin {

  credentials = {
    email: '',
    password: '',
  };

  errorMessage = '';
  loading = false;
  showPassword = false;

  togglePassword() {
    this.showPassword = !this.showPassword;
    const input = document.getElementById('password') as HTMLInputElement;
    input.type = this.showPassword ? 'text' : 'password';
  }

  constructor(
    private router: Router, 
    private auth: AuthService,
    private logger: LogService
  ) { }

  onSubmit() {
    this.errorMessage = '';
    this.loading = true;

    this.auth.login(this.credentials).subscribe({
      next: () => {
        this.loading = false;
        // redirection après login
        this.router.navigate(['/']);
      },
      error: (err) => {
        this.loading = false;
        this.errorMessage = 'Identifiants invalides';
        this.logger.error('Login failed: ' + JSON.stringify(err));
      }
    });
  }

}
